// extracted by mini-css-extract-plugin
module.exports = {"sigContainer":"styles_sigContainer__2e4IH","sigPad":"styles_sigPad__2fcv6"};